module.exports = __webpack_public_path__ + "static/media/K plus 3in1.1a3c5544.jpg";